// Tech-rider copy. Single source of truth for the on-page TechRider section
// AND the tech-rider.pdf generated for the media-kit zip (see
// scripts/build-media-kit.js). Bullet structure keeps the PDF generator
// simple — one bullet per line.

export const TECH_RIDER_INTRO =
  "Each griddle requires a 1500W / 120V outlet on a circuit not shared with other heavy equipment, plus a 6' table. Poffridge's Bar requires a second circuit.";

export const TECH_RIDER_BULLETS = [
  { label: "Power", value: "1500W / 120V outlet per griddle, on a circuit not shared with other heavy equipment. Poffridge's Bar requires a second circuit." },
  { label: "Tables", value: "One 6' table per station." },
  { label: "Footprint", value: "10×10 preferred; 6×6 minimum for performance-only." },
  { label: "Water", value: "Potable water access." },
  { label: "Display", value: "HDMI input to a client-provided screen or projector for live overlay." },
  { label: "International", value: "Accommodated on a case-by-case basis — power conversion, equipment adaptation, and customs handled in pre-production." },
];

export const TECH_RIDER_FOOTNOTE =
  "Detailed rider available on booking.";
